// ModalActivo.jsx
import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, MenuItem
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";

const API = "https://api.hmsaa.com.mx:5001/api";

export default function ModalActivo({
  open,
  onClose,
  editing,
  departamentos,
  lastDepartamentoId,
  refresh
}) {
  const [form, setForm] = useState({
    numero: "",
    descripcion: "",
    id_departamento: ""
  });

  useEffect(() => {
    if (!open) return;

    if (editing) {
      axios.get(`${API}/activos/${editing}`)
        .then(res => {
          setForm({
            numero: res.data.numero,
            descripcion: res.data.descripcion,
            id_departamento: String(res.data.id_departamento)
          });
        })
        .catch(() => {
          Swal.fire("Error", "No se pudo cargar el activo", "error");
        });
    } else {
      setForm({
        numero: "",
        descripcion: "",
        id_departamento: lastDepartamentoId
          ? String(lastDepartamentoId)
          : departamentos[0]?.id_departamento?.toString() || ""
      });
    }
  }, [open, editing, departamentos, lastDepartamentoId]);

  const guardar = async () => {
    try {
      if (!form.numero || !form.descripcion || !form.id_departamento) {
        Swal.fire("Faltan datos", "Todos los campos son obligatorios", "warning");
        return;
      }

      if (editing) {
        await axios.put(`${API}/activos/${editing}`, form);
      } else {
        await axios.post(`${API}/activos`, form);
      }

      await refresh();

      Swal.fire({
        icon: "success",
        title: editing ? "Activo actualizado" : "Activo creado",
        timer: 1200,
        showConfirmButton: false
      });

      onClose();
    } catch (e) {
      const msg = e.response?.data?.error || "Error inesperado";
      Swal.fire("Error", msg, "error");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {editing ? "Editar Activo" : "Nuevo Activo"}
      </DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          label="Número"
          sx={{ mb: 2 }}
          value={form.numero}
          onChange={e => setForm({ ...form, numero: e.target.value })}
        />

        <TextField
          fullWidth
          label="Descripción"
          sx={{ mb: 2 }}
          value={form.descripcion}
          onChange={e => setForm({ ...form, descripcion: e.target.value })}
        />

        <TextField
          fullWidth
          select
          label="Departamento"
          value={form.id_departamento}
          onChange={e =>
            setForm({ ...form, id_departamento: e.target.value })
          }
        >
          {departamentos.map(d => (
            <MenuItem key={d.id_departamento} value={d.id_departamento}>
              {d.abreviatura} — {d.nombre}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={guardar}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
